export const mediaMaxBytesForAiGrading = 20_000_000; // 20 mb

export const aiGradingFileTypesText = {
  txt: 'txt',
  text: 'text',
  doc: 'doc',
  docx: 'docx',
  pdf: 'pdf',
};

export const aiGradingFileTypesImage = {
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg',
  jfif: 'jfif',
  webp: 'webp',
  gif: 'gif (non-animated)',
  bmp: 'bmp',
  tiff: 'tiff',
  tif: 'tif',
};

export const aiGradingFileTypesCoding = {
  bash: 'bash',
  bat: 'bat',
  c: 'c',
  cpp: 'cpp',
  css: 'css',
  go: 'go',
  htm: 'htm',
  html: 'html',
  java: 'java',
  json: 'json',
  jsp: 'jsp',
  jsx: 'jsx',
  md: 'md',
  php: 'php',
  py: 'py',
  r: 'r',
  scss: 'scss',
  sh: 'sh',
  sml: 'sml',
  sql: 'sql',
  swift: 'swift',
  ts: 'ts',
  tsx: 'tsx',
  xml: 'xml',
  yml: 'yml',
  js: 'js',
};

export const aiGradingFileTypesAudio = {
  mp3: 'mp3',
  wav: 'wav',
  aac: 'aac',
  flac: 'flac',
};

export const aiGradingFileTypesVideo = {
  mp4: 'mp4',
  mov: 'mov',
  wmv: 'wmv',
  webm: 'webm',
};

// value is the label for the file type in key
export const allowedFileTypesForAiGrading = {
  ...aiGradingFileTypesText,
  ...aiGradingFileTypesImage,
  ...aiGradingFileTypesCoding,
  ...aiGradingFileTypesAudio,
  ...aiGradingFileTypesVideo,
} as const;

export const aiGradingFileTypesVideoOeq = {
  mp4: 'mp4',
  mov: 'mov',
  webm: 'webm',
};
